import { Partenaire } from '../../../shared/models/partenaire.model';
import { PartenaireService } from '../../../shared/services/partenaire.service';
import {Inject} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';

export class PartenairesDetailsResolver implements Resolve<Partenaire> {

  constructor( @Inject(PartenaireService) private userService: PartenaireService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Partenaire> {
    return this.userService.findById(+route.paramMap.get('id'));
  }
}
